<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import settings from './backend/LocalSettings'
import { EventBus } from './backend/EventBus.js';

export default {
  name: "app",
  data () {
    return { }
  },
  methods: {
    tick() {
      if( settings.is_logged_in() )
      {
        this.$http
          .post('dashboard/ping',  {  } )
          .then(function (response) {
            this.tableLoadingVisible = false;
            if( settings.verify_response(response, this.$rights)) {
              if( response.body.UnapprovedProductsCount > 0 || response.body.UnapprovedCategoriesCount > 0 )
              {
                EventBus.$emit('on_menu_notification_change', response.body.UnapprovedProductsCount, response.body.UnapprovedCategoriesCount);
              }
            } else {
              this.$router.push("/");
            }
          }); 
      }
    },
    async check_version()
    {
      var local_version  = settings.version;
      var server_version = await this.post("version");
      if( local_version != server_version )
      {
        this.$notify({
          title: 'Warning',
          message: 'New version available - <button onclick="window.location.reload()">Upgrade</button> ',
          dangerouslyUseHTMLString: true,
          type: 'warning',
          duration: 0
        });
      }
    },
    async post(url, args={}){
      var response = await this.$http.post(url, args );
      return response.bodyText;
    },
  },
  mounted: function() {
    setInterval( this.tick, 1000 * 30 );
    this.check_version();
  }
}
</script>

<style lang="less">
html {
  height: 100%;
  background-position: center;
  background-size: cover;
  background-position: fixed;
  background-image: linear-gradient(to bottom, #30c6e6 0%, rgba(84, 167, 216, 0.6) 100%), url(./assets/login-bg.jpg);
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
body{
  background-color: transparent !important;
}

.my-dialog-class
{ 
  .el-dialog{
      width:100%;
      @media(min-width: 768px)
      {
          width: 50%;
      } 
  }
}

.el-table td{
  padding:0px !important;

  p{
    padding:0;
    margin:0;
  }
}
</style>
